

exports.__esModule = true;

var _squid = require('squid');

require('xo-ui-components/src/error-tooltip/directive');

require('xo-ui-components/src/prefix-attrs-with/directive');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoZipcode', {
    tag: 'xo-zipcode',

    template: _template2['default'],

    props: {
        address: {
            reqiured: 'true',
            type: 'var'
        },
        attrPrefix: {
            required: 'false',
            type: 'var'
        },
        country: {
            required: 'true',
            type: 'str'
        },
        doneFn: {
            required: 'true',
            type: 'var'
        },
        keyPressFn: {
            required: 'false',
            type: 'var'
        },
        maxLength: {
            required: 'true',
            type: 'var'
        },
        postalCodeLabel: {
            required: 'false',
            type: 'var'
        },
        zipEntry: {
            required: 'false',
            type: 'var'
        },
        zipErrorKey: {
            required: 'true',
            type: 'str'
        },
        zipLabel: {
            required: 'true',
            type: 'str'
        },
        zipRequired: {
            reqiured: 'false',
            type: 'var'
        }
    },

    lifecycle: {
        enter: function enter() {
            this.formatRegex = undefined;
            this.inputParams = (0, _squid.$feature)('zipcodeInputParams', undefined, this.country);

            if (this.inputParams) {
                this.minLength = this.inputParams.minLength;
                this.maxLength = this.inputParams.maxLength;

                if (this.inputParams.formatPattern) {
                    this.formatRegex = new RegExp(this.inputParams.formatPattern, 'g');
                }
            }

            this.formatZipWithDash = function (zipcode, index) {
                if (zipcode.length > index) {
                    zipcode = zipcode.slice(0, index) + '-' + zipcode.slice(index);
                }

                return zipcode;
            };
        }
    },

    actions: {
        changeZip: function changeZip(zipcode) {
            if (zipcode) {

                if (this.formatRegex) {
                    zipcode = zipcode.replace(this.formatRegex, '');
                }

                if (this.inputParams && this.inputParams.formatZip) {
                    zipcode = this.formatZipWithDash(zipcode, this.inputParams.minLength);
                }

                this.address.postal_code = zipcode;
            }
        },
        doneFunction: function doneFunction() {
            if (this.doneFn) {
                this.doneFn();
            }
        },
        keyPressHandler: function keyPressHandler(event) {
            if (this.keyPressFn) {
                this.keyPressFn(event);
            }
        }
    }
});


_squid.$Component;

_squid.$feature;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./components/xo-form-components/src/zipcode/directive.js
// module id = ./components/xo-form-components/src/zipcode/directive.js
// module chunks = 1